import React from 'react';
import cn from 'clsx';

import BarRatingItem from './bar-rating-item/bar-rating-item';

import styles from './bar-rating.scss';

export interface AverageRating {
  label: string;
  value: number;
}

interface BarRatingProps {
  averageRatings: AverageRating[];
  className?: string;
  heading?: string;
  headingTag?: keyof JSX.IntrinsicElements;
}

function BarRating(props: BarRatingProps) {
  const {
    averageRatings,
    className,
    heading = '',
    headingTag: HeadingTag = 'h5'
  } = props;

  return (
    <div className={cn(styles['container'], `${className || ''} bar-rating`)}>
      {heading && (
        <HeadingTag className={styles['section-heading']}>{heading}</HeadingTag>
      )}
      <div className={cn(styles['average-ratings'], 'bar-rating__ratings')}>
        <div
          className={cn(
            styles['average-ratings-section'],
            'bar-rating__ratings-section'
          )}
        >
          {averageRatings.map(averageRating => (
            <BarRatingItem
              averageRating={averageRating}
              key={averageRating.label}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export { BarRatingItem };
export default BarRating;
